(function() {

    'use strict';

    angular.module('eclipseApp.myAccount')

      .controller('changePhoneNumberRedesignReviewCtrl', ['$scope', 'provinceMeta', '$sce', '$http', 'uteEndpoint', 'uteLocale', '$rootScope', '$stateParams', '$state', '$previousState', 'commonService', 'changePhoneNumberService', 'dataLayerService', 'dtmServiceConstants', function($scope, provinceMeta, $sce, $http, uteEndpoint, uteLocale, $rootScope, $stateParams, $state, $previousState, commonService, changePhoneNumberService, dataLayerService, dtmServiceConstants) {

        $scope.reviewPage = true;
        $scope.hideEmailDiv = false;

        $scope.newCtn = $stateParams.newCTN;
        $scope.oldCtn = $stateParams.oldCTN;
        $scope.cityName = changePhoneNumberService.getCityName();
        $scope.provinceName = changePhoneNumberService.getProvince();
        $scope.accountNumber = $stateParams.accountNumber;
        $scope.selectedAccountNumber = $stateParams.accountNumber;
        $scope.customerFirstName = $rootScope.userInfo.firstName;
        $scope.customerLastName = $rootScope.userInfo.lastName;
        $scope.planIsCollapsed = false ;
        $scope.language = uteLocale.language;
        var selectedAccountDetail = '';

        var selectedAccountDetail;
        if ($scope.selectedAccountNumber) {
          selectedAccountDetail = _.find(commonService.accountDetails, function(accountDetail) {
              return accountDetail.accountNumber === $scope.selectedAccountNumber;
          });
          console.log('selectedAccountDetail', selectedAccountDetail);
        }

        if (selectedAccountDetail) {
          $scope.customerEmail = selectedAccountDetail.contactEmail;
        }

        if (_.isEmpty($scope.customerEmail)) {
          $scope.hideEmailDiv = true;
        }

        var accountNumber = $stateParams.accountNumber;
        if (selectedAccountDetail) {
          if (selectedAccountDetail.LOB === 'WL') {
            $scope.customerType = 'postpaid';
          } else {
            $scope.customerType = 'prepaid';
          }
        }

        $scope.trackChangeNumber = function(step, addBasicSections) {
          var  selfServe = {};
          var  event = {};
          var  page = dtmServiceConstants.dataLayerTrack.page.changeCtn[step];

          /**
           * Set event for SelfServe transaction
           */
          if (step === 'complete') {
            event.selfServeComplete = true;
            selfServe = dtmServiceConstants.dataLayerTrack.selfServe.changeCtn;
            page = dtmServiceConstants.dataLayerTrack.page.changeCtn.complete;
          }

          var payload = {
            page: page,
            selfServe: selfServe,
            events: event
          };

          /**
           * Remove empty objects from payload
           */
          if (_.isEmpty(payload.events)) {
            delete payload.events;
          }
          if (_.isEmpty(payload.selfServe)) {
            delete payload.selfServe;
          }
          dataLayerService.trackDataLayer(payload, false, addBasicSections);
        };

        $scope.validateCtn = function() {
          $http({
            method: "POST",
            url: uteEndpoint('v1/wirelesss/changenumber/submit'),
            data: {
              accountNumber: $stateParams.accountNumber,
              ctn: $scope.oldCtn,
              cityCode: $stateParams.cityCode,
              newTelephoneNo: $scope.newCtn,
              customerFirstName: $rootScope.userInfo.firstName,
              customerLastName: $rootScope.userInfo.lastName,
              email: $scope.customerEmail,
              accountType: $scope.customerType,
              province: $scope.provinceName,
              language: uteLocale.language
            }
          }).success(function(Response) {
            if (_.isEmpty(Response.error)) {
              $scope.reviewPage = false;
              $scope.confirmPage = true;
              $scope.showError = false;
              $scope.trackChangeNumber(dtmServiceConstants.actions.completeEvent, dtmServiceConstants.dataLayerTrack.basicPayloadSections);
            } else {
              $scope.showError = true;
            }
          }).error(function(Response) {
              $scope.showError = true;
          });
        }

        $scope.cancel = function() {
          if (angular.isDefined($previousState.get())) {
            $previousState.go();
          }
        };

    }]);

})();
